/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 26/7/2021
 * @Example
 */


import React, { useRef, useState, memo } from 'react';
import { Column } from "devextreme-react/data-grid";
import GridContainer from "../../../grid-container/grid-container";
import Config from '../../../../config/index';
import GridActionBar from '../../../grid-container/grid-actionbar';
import { ButtonIcon, Tooltip } from 'diginet-core-ui/components'
// import UserImage from "../../../common/user/user-image";
import PopoverAction from '../../../grid-container/popover-action';
import { browserHistory } from 'react-router';
import { Approval, Loading } from 'diginet-core-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    approved: {
        '& path': {
            fill: theme.palette.success.main
        },
        '& span': {
            color: theme.palette.success.main,
            paddingLeft: 5
        }
    },
    pending: {
        '& path': {
            fill: theme.palette.secondary.main
        },
        '& span': {
            color: theme.palette.secondary.main,
            paddingLeft: 5
        }
    }
}));
const W06F0008GridTabContent = memo((props) => {
    const { data, onChangePage, onChangePerPage, filter, permission, onCheck, onOpenModalAprrove, approvePermission } = props;
    const classes = useStyles();
    const popoverGrid = useRef(null);
    const [item, setItem] = useState(null);

    const renderActions = (e) => {
        // const { data } = e;
        return (
            Config.isMobile ? <ButtonIcon viewType="text" size="tiny" name="more" color='primary' onClick={(el) => handleClick(el, e)} /> :
                <GridActionBar>
                    <ButtonIcon viewType="text" size="tiny" name="more" color='primary' onClick={(el) => handleClick(el, e)} />
                </GridActionBar>
        );
    };

    const handleClick = (e, currentItem) => {
        const target = e.currentTarget;
        setItem(currentItem);
        if (popoverGrid.current) popoverGrid.current.instance.show(target);
    };

    const onHandleActions = (key) => {
        popoverGrid.current.instance.hide();
        let pathname = 'W06F0009';
        const params = {
            ContractID: item.data.ContractID,
            SubContractID: item.data.SubContractID,
            ContractNo: item.data.ContractNo,
            SubContractNo: item.data.SubContractNo,
            IsApprove: item.data.IsApprove,
        };
        switch (key) {
            case 'edit':
                params.mode = 'edit';
                onCheck(params, 'edit', item);
                break;
            case 'delete':
                onCheck(params, 'delete', item);
                break;
            case 'approve':
                if (approvePermission < 4) {
                    Config.popup.show("INFO", Config.lang("Ban_khong_co_quyen_duyet"));
                    return false;
                }
                onOpenModalAprrove(item);
                break;
            case 'copy':
                browserHistory.push({
                    pathname: Config.getRootPath() + pathname,
                    state: { ...item.data, mode: 'add' }
                });
                break;
            default:
                break;
        }
    }

    const renderIcons = () => {
        return (
            <div>
                <PopoverAction
                    reference={ref => popoverGrid.current = ref}
                    position={"right"}
                    maxWidth={300}
                    deferRendering={false}
                >
                    <div className="display_row align-center" style={{ padding: 4 }}>
                        <Tooltip title={Config.lang('Sua')}>
                            <ButtonIcon viewType="text" size="tiny" name="edit" color='primary' disabled={!(permission > 1)}
                                onClick={() => onHandleActions('edit')} />
                        </Tooltip>
                        <Tooltip title={Config.lang('Xoa')}>
                            <ButtonIcon viewType="text" size="tiny" name="delete" color='primary' disabled={!(permission > 2)}
                                onClick={() => onHandleActions('delete')} />
                        </Tooltip>
                        <Tooltip title={Config.lang('Sao_chep')}>
                            <ButtonIcon viewType="text" size="tiny" name="copy" color='primary' disabled={!(permission > 0)}
                                onClick={() => onHandleActions('copy')}
                            />
                        </Tooltip>
                        <Tooltip title={Config.lang('Duyet')}>
                            <ButtonIcon viewType="outlined" size="tiny" name="approval" color='primary' circular
                                style={{ width: 20, height: 20 }}
                                onClick={() => onHandleActions('approve')} />
                        </Tooltip>
                    </div>
                </PopoverAction>

            </div>
        )
    }

    const renderStatus = (e) => {
        return Number(e.data.IsApprove) ? <div className={classes.approved}><Approval /><span>{Config.lang('Da_duyet')}</span></div> :
            <div className={classes.pending}><Loading /><span>{Config.lang("Chua_duyet")}</span></div>;
    }

    const renderUser = (e) => {
        return (
            <div className="display_row align-center">
                {/* <UserImage data={e.data} keyExpr={"EmployeeID"} allowHover={false} /> */}
                <span>{e.data.EmployeeName}</span>
            </div>
        )
    }

    const numberFormat = (number, limitNumber = 0) => {
        const formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: limitNumber,
            maximumFractionDigits: limitNumber,
        });
        const _number = formatter.format(String(number));
        return !_number || _number === "NaN" ? 0 : _number;
    };

    const cellRenderNumber = (e, decimal) => {
        if (Config.isEmpty(e.displayValue) && e.displayValue !== 0) return null;
        return numberFormat(e.displayValue, decimal ?? 0);
    }

    return (
        <div id="gridW06F0008">
            {data?.total > 0 && renderIcons()}
            <GridContainer
                listPerPage={[20, 30, 45, 60]}
                dataSource={data?.rows ?? []}
                totalItems={data?.total ?? 0}
                itemPerPage={filter.limit}
                skipPerPage={filter.skip}
                onChangePage={onChangePage}
                onChangePerPage={onChangePerPage}
                hoverStateEnabled={true}
                height={"calc(100vh - 250px)"}
                onDbCellClick={e => {
                    if (e.data && permission > 0) {
                        browserHistory.push({
                            pathname: Config.getRootPath() + 'W06F0010',
                            state: {
                                ContractID: e.data.ContractID,
                                SubContractID: e.data.SubContractID,
                                ContractNo: e.data.ContractNo,
                                IsApprove: e.data.IsApprove,
                                mode: 'view'
                            }
                        });
                    }
                }}
            >
                <Column caption={Config.lang('So_phu_luc')} dataField={'SubContractNo'} width={200} />
                <Column caption={Config.lang('So_hop_dong')} dataField={'ContractNo'} width={200} />
                <Column caption={Config.lang('Nha_cung_cap')} dataField={'ObjectNameU'} width={380} />
                <Column caption={Config.lang('Ngay_lap')} dataField={'CreateDate'} width={180}
                    alignment={"center"} dataType="date" format="dd/MM/yyyy" />
                <Column caption={Config.lang('Nguoi_lap')} dataField={'EmployeeName'} cellRender={renderUser} width={250} />
                <Column caption={Config.lang('Loai_phu_luc')} dataField={'SubContractTypeName'} />
                <Column caption={Config.lang('Trang_thai')} dataField={'IsApprove'} cellRender={renderStatus} width={200} />
                <Column caption={Config.lang('Loai_tien')} dataField={'CurrencyID'} width={130} />
                <Column caption={Config.lang('Ty_gia')} dataField={'ExchangeRate'} width={130} cellRender={cellRenderNumber} />
                <Column caption={Config.lang('Ngay_bat_dau')} dataField={'StartDate'} width={180}
                    alignment={"center"} dataType={"date"} format={"dd/MM/yyyy"} />
                <Column caption={Config.lang('Ngay_ket_thuc')} dataField={'FinishDate'} width={180}
                    alignment={"center"} dataType={"date"} format={"dd/MM/yyyy"} />
                <Column caption={''} allowEditing={false} alignment={"right"} fixed={true} fixedPosition={"right"}
                    cellRender={renderActions} />
            </GridContainer>
        </div>
    );
})

export default W06F0008GridTabContent;
